export const baseDialogStyles = (theme) => ({
    header: {
        padding: 20
    },
    subTitle: {
        color: theme.palette.text.subTitle
    },
    content: {
        padding: '30px 40px 10px'
    },
    icon: {
        fontSize: theme.typography.icon.default * 0.8, // 24px
        marginRight: 20,
        verticalAlign: 'middle'
    }
});
